import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  AuthService,
  CustomersService,
  EventsService,
  ReportsService,
  RoleService,
  StatusService,
  TimerService,
  UsersService,
  TimeService,
  DashboardService
} from './services.index';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    AuthService,
    CustomersService,
    EventsService,
    ReportsService,
    RoleService,
    StatusService,
    TimerService,
    UsersService,
    TimeService,
    DashboardService
  ],
  declarations: []
})
export class ServicesModule { }



// WEBPACK FOOTER //
// ./src/app/services/services.module.ts